import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import i18n from './i18n'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './assets/css/tailwind.css'
import ClickOutside from 'vue-click-outside-directive' // Import the directive

// Die Simulation von Vite-Umgebungsvariablen ist nicht mehr notwendig und wurde entfernt.

// Importiere die Umgebungskonfiguration zuerst, damit sie
// vor allen anderen Services initialisiert wird
import { AppConfig, CURRENT_ROLE } from './utils/environmentConfig'
console.log('Umgebungskonfiguration geladen:', AppConfig)

// Importiere die globalen Styles und das Theme
import './assets/css/theme.css';

// Importiere Tailwind - stelle sicher, dass dies NACH deinem Theme importiert wird,
// damit Tailwind-Utilities die Variablen überschreiben können, falls nötig.
import './assets/css/tailwind.css'; // Dieser Pfad sollte korrekt sein

import { useUserStore } from './stores/user'
// import store from './stores' // Legacy-Store-Import entfernt
import { useThemeStore } from './stores/theme'; // Importiere den Theme Store
import { useAuthStore } from './stores/auth'; // Importiere den Auth Store
import { useRestaurantStore } from './stores/restaurant'; // Importiere den Restaurant Store

// Get store before app mount - entfernt, da userStore.initFromLocalStorage() dies übernimmt
// const storedUserData = JSON.parse(localStorage.getItem('userStore')) 
// if (storedUserData) { 
//   store.state.user = storedUserData 
// }

const app = createApp(App)
const pinia = createPinia()

// Toast-Konfiguration
const toastOptions = {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true
}

app.use(pinia)

// Initialisiere Stores NACHDEM Pinia verwendet wird
// eslint-disable-next-line no-unused-vars
const themeStore = useThemeStore(); // Theme Store initialisieren
const authStore = useAuthStore();   // Auth Store Instanz holen
authStore.initializeAuth();       // Auth Store aus LocalStorage initialisieren

// Den User Store auch initialisieren (wenn er noch benötigt wird neben authStore)
const userStore = useUserStore();
userStore.initFromLocalStorage();

// Initialisierung der App
const initApp = async () => {
  try {
    // Prüfe, ob der Benutzer bereits angemeldet ist
    if (authStore.isAuthenticated) {
      console.log('Initialisierung: Authentifizierter Benutzer erkannt, lade Restaurant-Einstellungen...')
      const restaurantStore = useRestaurantStore()
      await restaurantStore.fetchRestaurantSettings()
    }
    
    // Basierend auf der erkannten Rolle können wir verschiedene Initialisierungen durchführen
    console.log('App wird mit Rolle initialisiert:', CURRENT_ROLE)
  } catch (error) {
    console.error('Fehler bei der Initialisierung:', error)
  }
}

app.use(router)
// app.use(store) // Legacy-Store-Verwendung entfernt
app.use(i18n)
app.use(Toast, toastOptions)

// Register the directive globally
app.directive('click-outside', ClickOutside)

// App mounten
app.mount('#app')

// Initialisierung starten
initApp()
